import Button from '@ui/Button'
import Breadcrumb from '@common/Breadcrumb'
import {ROUTES,SITE } from '@/constants'
import { Link, Route } from 'react-router-dom'
import MetaInfo from '@/components/common/MetaInfo'
import TransformBanner from '@sections/TransformBanner'
import { metaTitleFor } from '../assets/js/navBreadcrumb'
const { label, pageDesc, metaDesc } = metaTitleFor(ROUTES.AI_USECASES_BUSINESS_APPLICATIION)


const RIGHT_AI_APPROACH = [
  { requirement: 'Generate answers from company documents', approach: 'Generative AI with retrieval and source grounding' },
  { requirement: 'Extract information from documents', approach: 'AI document processing and validation' },
  { requirement: 'Route requests to the right team', approach: 'Classification with workflow automation' },
  { requirement: 'Coordinate a sequence of permitted tasks', approach: 'Workflow orchestration and controlled AI agents' },
  { requirement: 'Forecast demand or workload', approach: 'Statistical forecasting or machine learning' },
{ requirement: 'Identify unusual patterns', approach: 'Anomaly detection' },
  { requirement: 'Recommend products or content', approach: 'Recommendation systems' },
  { requirement: 'Add AI features to an existing application', approach: 'AI integration using suitable APIs and application architecture' },
 
]

const AI_SERVICES = [
  {  title: 'AI Integration & Application Development',        desc: 'Manage servers, environments, deployments, monitoring, backups, configurations, and operational infrastructure for dependable application delivery.',link: ROUTES.DEVOPS },
  {  title: 'Generative AI & Intelligent Assistants',     desc: 'Migrate, manage, modernize, secure, and optimize cloud environments based on your applications and business requirements.', link: ROUTES.CLOUD_SERVICES},
  {  title: 'AI Workflow Automation & Agents',  desc: 'Manage domains, DNS, business email, hosting, SSL, backups, migrations, and the essential services behind your digital presence.',link: ROUTES.DOMAIN_DNS_EMAIL_SERVER_MANAGEMENT  },
  {  title: 'AI & Machine Learning Solutions',  desc: 'Manage domains, DNS, business email, hosting, SSL, backups, migrations, and the essential services behind your digital presence.',link: ROUTES.DOMAIN_DNS_EMAIL_SERVER_MANAGEMENT  },
]
export default function AiUseCases() {
  

  return (<><MetaInfo
     title={label}  
    description={metaDesc}
   keywords=""
  />
      <main id="main-content" className="page-wrapper">
         <div className="page-hero">
           <div className="bg-grid bg-grid--fill" aria-hidden="true" />
           <div className="container">
             {/* <div className="section-label">- AI/ML Solutions -</div> */}
              <Breadcrumb />
             <h1>{label}</h1>
             <p className="page-subtitle">
            {pageDesc}
             </p>
            
             <div className="inner-page-actions">
               <Button  href={ROUTES.SALES_ENQUIRY}  variant="primary" icon="fa-arrow-right" iconPos="right">
                 Get a Free Quote
               </Button>
              
             </div>
           </div>
         </div>
         
   <section className="section-py bg-linear-gradient-light " aria-labelledby="we-assess-heading">
      <div className="container">
        <p className='text-center'>Not every AI opportunity requires the same technology. The right approach depends on the task, the available data and the level of reliability and control required.</p>

        <div className="comparison-table" role="table" aria-label="Comparison of other providers versus us"  data-aos="fade-up">
          <div className="comparison-row comparison-row--head" role="row">
            <div className="comparison-cell comparison-cell--head comparison-cell--requirement" role="columnheader">
              Business requirement
            </div>
            <div className="comparison-cell comparison-cell--head comparison-cell--ours" role="columnheader">
              Potential approach
            </div>
          </div>

          {RIGHT_AI_APPROACH.map(row => (
            <div className="comparison-row" role="row" key={row.requirement}>
              <div className="comparison-cell comparison-cell--requirement" role="cell">
                <span>{row.requirement}</span>
              </div>
              <div className="comparison-cell comparison-cell--ours" role="cell">
                {row.approach}
              </div>
            </div>
          ))}
        </div>
        <p className='pt-4 text-center'>Sometimes conventional software rules, search technology or standard analytics are more appropriate than AI. A good solution uses AI where it provides a genuine advantage, rather than adding it simply because it is available.
</p>
      </div>
    </section>

  <section className="sc-section section-py " aria-labelledby="uiux-process-heading">
            <div className="container">
              <div className="text-center" data-aos="fade-up">
                Whether you want to add intelligence to an existing application, help users interact with information through conversational AI, automate repetitive processes or build data-driven features, CruxBytes can help you evaluate the opportunity and develop a suitable software solution. Start with the business challenge. The right AI capability follows from what you need to improve.
              </div>
              {/* UX / UI Design Process Tree */}
  <div className="policy-tree-section">
    <div className="text-center">
      <span className="policy-root" id="policy-root-node" data-aos="fade-up">
        Explore our AI development services
      </span>
    </div>
  
    <div className="policy-tree-connector" data-aos="fade-up" data-aos-delay={100}>
    <svg
      id="policy-tree-svg"
      viewBox="0 0 1200 140"
      preserveAspectRatio="xMidYMid meet"
      aria-hidden="true"
    >
      <path
        id="ux-branch-1"
        className="branch-line"
        d="M 600,0 L 600,45 Q 600,70 550,70 L 150,70 Q 130,70 130,95 L 130,140"
      />
  
      <path
        id="ux-branch-2"
        className="branch-line"
        d="M 600,0 L 600,45 Q 600,70 570,70 L 400,70 Q 380,70 380,95 L 380,140"
      />
  
      <path
        id="ux-branch-3"
        className="branch-line"
        d="M 600,0 L 600,45 Q 600,70 630,70 L 800,70 Q 820,70 820,95 L 820,140"
      />
  
      <path
        id="ux-branch-4"
        className="branch-line"
        d="M 600,0 L 600,45 Q 600,70 650,70 L 1050,70 Q 1070,70 1070,95 L 1070,140"
      />
  
      <circle
        className="travel-dot"
        id="travel-dot-ux"
        cx="600"
        cy="0"
        r="5"
      />
    </svg>
  </div>
  
    <div className="policy-cards-row policy-cards-row--four">
     {AI_SERVICES.map(({ icon, title, desc, link }) => (
       <li className="policy-card policy-card--link bg-linear-gradient-light" key={title}>    
         <h6>{title}</h6>
         <span className="policy-card--desc">{desc}</span>
         <Link to={link} className="wcs-arrow" aria-label={`Learn more about ${title}`}>
           <i className="fa-solid fa-arrow-right" aria-hidden="true" />
         </Link>
       </li>
     ))}
    </div>
  </div>
              
      <div className="text-center" data-aos="fade-up" >
      Let's identify where AI can make your existing software and business processes more useful, efficient and adaptable.

    </div>
        
            </div>
          </section>
         <TransformBanner />
         </main></>
  )
}